<template>
  <b-button
    :variant="variant"
    :disabled="disabled"
    :type="type"
    @click="onClick"
  >
    <slot></slot>
  </b-button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    variant: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    type: {
      type: String,
      required: false,
    },
  },
  methods: {
    onClick($event) {
      this.$emit('click', $event);
    },
  },
};
</script>

<style scoped>
.btn {
  border-radius: 22px;
  padding: 10px 30px;
}
.btn:focus,
.btn:active {
  outline: none !important;
  box-shadow: none;
}
</style>
